// extracted by mini-css-extract-plugin
export default {"BackToRepositorySelectionButton":"RepositoryAndIssuePicker-module__BackToRepositorySelectionButton--bl2wm"};